<template>
  <div>
    <ForeignOrganizationFields :v="v" />

    <ExtractionRodAssignee
      :v="v.assignee"
      label="Сведения о представителе иностранного юридического лица"
    />
  </div>
</template>

<script>
import deepmerge from 'deepmerge';
import {
  getValidationErrorText,
} from '@/utils/validate';
import ExtractionRodAssignee, {
  assigneeModel,
  assigneeValidate,
} from './ExtractionRodAssignee';
import ForeignOrganizationFields, {
  foreignOrganizationFieldsModel,
  foreignOrganizationFieldsValidation,
} from '@/components/services/ExtractionRod/Applicant/ForeignOrganizationFields';

export const foreignOrganizationModel = deepmerge.all([
  foreignOrganizationFieldsModel,
  { assignee: assigneeModel },
]);

export const getForeignOrganizationValidation = (foreignOrganization) => ({
  ...foreignOrganizationFieldsValidation,
  assignee: assigneeValidate(foreignOrganization.assignee),
});

export default {
  name: 'ForeignOrganization',
  props: {
    v: {
      type: Object,
      required: true,
    },
    trusteeRole: {
      type: String,
      required: true,
    },
  },
  components: {
    ForeignOrganizationFields,
    ExtractionRodAssignee,
  },
  data: () => ({
    getValidationErrorText,
  }),
};
</script>
